import { render, staticRenderFns } from "./PostContentMediaSelection.vue?vue&type=template&id=c6e346d0&scoped=true"
import script from "./PostContentMediaSelection.vue?vue&type=script&lang=js"
export * from "./PostContentMediaSelection.vue?vue&type=script&lang=js"
import style0 from "./PostContentMediaSelection.vue?vue&type=style&index=0&id=c6e346d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e346d0",
  null
  
)

export default component.exports